import React, { FC } from 'react';
import { Grid, Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { liveOrderCountsContext } from 'apollo/order-live-updates';
import { workflowOverviewIncomingTemplate } from 'apollo/templates/workFlow';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import PageTitle from 'components/shared/page-title/page-title.component';
import StaticStepBox from './static-step-box.component';
import { OverView } from 'models/workflow-step';

const IncomingSection: FC = () => {
    const { t: translate } = useTranslation(['workflow']);
    const { showBoundary } = useDenthubErrorBoundary();

    const { loading, data: result } = useQuery(workflowOverviewIncomingTemplate, {
        context: liveOrderCountsContext,
        fetchPolicy: 'network-only',
        onError(error) {
            showBoundary(error);
        },
    });
    // Registered as a count view: an ORDER_CHANGED refresh (DD-3231) re-reads it into the cache.
    const data: OverView = result?.workflowOverviewIncoming ?? ({} as OverView);

    return (
        <Box mb={4}>
            <PageTitle headingStyle="h2" title={translate('INCOMING')} />
            <Grid container spacing={1}>
                <Grid item md={3}>
                    {loading ? (
                        <Skeleton variant="rectangular" height={130} />
                    ) : (
                        <StaticStepBox
                            data={data}
                            filters={{ status: 'sent_by_customer' }}
                            title={translate('INBOX')}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default IncomingSection;
